export const SET_LOADING = 'SET_LOADING';

export const ADD_USER_MESSAGE = 'ADD_USER_MESSAGE';
export const ADD_TANUKI_MESSAGE = 'ADD_TANUKI_MESSAGE';
export const ADD_ERROR_MESSAGE = 'ADD_ERROR_MESSAGE';
